import { render, staticRenderFns } from "./NexvoDepositInstructions.vue?vue&type=template&id=64a5735c&scoped=true&"
import script from "./NexvoDepositInstructions.vue?vue&type=script&lang=js&"
export * from "./NexvoDepositInstructions.vue?vue&type=script&lang=js&"
import style0 from "./NexvoDepositInstructions.vue?vue&type=style&index=0&id=64a5735c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a5735c",
  null
  
)

export default component.exports